import { useParams, useNavigate } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { StandingsTable } from "@/components/StandingsTable";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Trophy, ArrowLeft } from "lucide-react";
import { useChampionship } from "@/contexts/ChampionshipContext";

export const StandingsPage = () => {
  const { championshipId } = useParams();
  const navigate = useNavigate();
  const { selectedChampionship } = useChampionship();
  
  const championship = selectedChampionship || {
    name: "Serie D Maschile Gir. A",
    series: "Serie D",
    gender: "Maschile",
    group: "A"
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <Navigation />
      
      <div className="container mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(`/championship/${championshipId}`)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Indietro
        </Button>
        
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-primary/10">
            <Trophy className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold mb-3">
            Classifica
          </h1>
          <p className="text-lg text-muted-foreground">
            {championship.series} {championship.gender} - Girone {championship.group}
          </p>
        </div>
        
        <StandingsTable />
      </div>
      
      <Footer />
    </div>
  );
};

export default StandingsPage;
